import React from "react";
import { Box, Typography } from "@mui/material";
import { useAtom } from "jotai";
import { loginAtom } from "../support/atoms";
import { LoginButton } from "@telegram-auth/react";
import { useMutation } from "urql";
import { telegramLoginMutation } from "../support/mutations";
import { useNotification } from "../hooks/useNotification";

export default function Login() {
  const [, setUser] = useAtom(loginAtom);
  const { showNotification } = useNotification();
  const [, login] = useMutation(telegramLoginMutation);

  const onTelegramAuth = async (user) => {
    showNotification("Logging in with Telegram...", {
      severity: "info",
      autoHideDuration: 3000,
    });
    await login({ input: user })
      .then((result) => {
        if (result?.error) {
          showNotification(result.error, {
            severity: "error",
            autoHideDuration: 3000,
          });
        }

        if (result?.data) {
          showNotification("Successfully logged in with Telegram", {
            severity: "success",
            autoHideDuration: 3000,
          });

          const { jwt, refreshToken, user } = result.data.telegramLogin;
          setUser({ user, jwt, refreshToken, role: user.role });
        }
      })
      .catch((error) => {
        showNotification(error.message, {
          severity: "error",
          autoHideDuration: 3000,
        });
      });
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        width: "100vw",
        bgcolor: "background.paper",
        position: "fixed",
        top: 0,
        left: 0,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          maxWidth: "450px",
          width: "100%",
          px: 3,
        }}
      >
        <Typography
          variant="h3"
          component="h1"
          gutterBottom
          sx={{
            fontWeight: 700,
            color: "primary.main",
            mb: { xs: 1, sm: 2 },
            fontSize: { xs: "2rem", sm: "2.5rem" },
          }}
        >
          DexEye
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: "text.secondary",
            mb: { xs: 3, sm: 4 },
            textAlign: "center",
            maxWidth: "90%",
            fontSize: { xs: "0.9rem", sm: "1rem" },
            lineHeight: 1.6,
          }}
        >
          Your intelligent companion for tracking and analyzing DeFi tokens
        </Typography>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            minHeight: "50px",
            mt: { xs: 1, sm: 2 },
          }}
        >
          <LoginButton
            botUsername={process.env.VITE_TELEGRAM_BOT_NAME}
            buttonSize={"large"}
            cornerRadius={8}
            onAuthCallback={(user) => {
              onTelegramAuth(user);
            }}
            showAvatar={true}
            lang="en"
          />
        </Box>
      </Box>
    </Box>
  );
}
